<div class="input-group">
    <input class="form-control" placeholder="dd/mm/aaaa"
           name="dp"  [disabled]="disabled" [formControl]="control" ngbDatepicker #d="ngbDatepicker">
    <div class="input-group-append">
        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="d.toggle()" type="button" [disabled]="disabled"></button>
    </div>
</div>
